import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import successImage from "../Images/Checked_Icon_UIA.svg"
import failImage from "../Images/Close_NA_Icon_UIA.svg"

const CustomResponse = () => {
//   const queryParams = new URLSearchParams(location.search);
const location = useLocation();
  const navigate = useNavigate();
const searchParams = new URLSearchParams(location.search);
const status = searchParams.get("status");
//   const isSuccess = "undefined;

  const messageStyle = {
    padding: '90px',
    borderRadius: '20px',
    textAlign: 'center',
    margin: '20px auto',
    maxWidth: '50%',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  };

  const successStyle = {
    ...messageStyle,
    backgroundColor: '#d1e7dd',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '24px', // Add this line to set the font size

  };

  const failStyle = {
    ...messageStyle,
    backgroundColor: '#f8d7da',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '24px', 
  };
  useEffect(() => {
    const navigateToHome = () => {
      navigate('/profile'); // Change '/home' to the actual path of your home page
    };

    // Set a timeout to wait for 3 seconds before navigating
    const timeoutId = setTimeout(navigateToHome, 3000);

    // Cleanup the timeout to prevent memory leaks
    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div>
      {status==="Success" && (
        <div style={successStyle}>
          <img src={successImage} alt='success' width="96px" height="96px"/>
          <p style={{color:"#00b22d"}}>Success! Your credit added to wallet successfully.</p>
        </div>
      
      )}
          {status==="Fail" && (
        <div style={failStyle}>
          <img src={failImage} alt='faild'/>
          <p style={{color:"#ff1414"}}>Oops! Something went wrong. Please try again.</p>
        </div>
      
      )}

    </div>


  );
};

export default CustomResponse;
